module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.6832/assets/images/homepage-screenshot.jpg"